import config from '../../config';

import availabilitiesTabComponentUrl from './availabilitiesTabComponent.html';

export class AvailabilitiesTab {
  constructor(Authentication, AvailabilityUtils, $scope, $uibModal) {
    'ngInject';

    Object.assign(this, { Authentication, AvailabilityUtils, $scope, $uibModal });
    this.UNAVAILABILITY_LIST_V2_ENABLED = config.UNAVAILABILITY_LIST_V2_ENABLED;
  }

  $onInit() {
    this.user = this.Authentication.user;
    this.readOnly = !this.user;
    this.loadSets();

    this.$scope.$on('socket:events:sync', () => {
      if (!this.form.$dirty) {
        this.loadSets();
      }
    });
  }

  get shouldRequest() {
    return this.AvailabilityUtils.shouldRequest();
  }

  get submitDisabled() {
    return !this.AvailabilityUtils.canSaveSets(this.availabilitySets);
  }

  async loadSets() {
    const canLoad = !this.readOnly && this.Authentication.isOrgFeatureEnabled('unavailability');
    this.availabilityLoading = canLoad;
    this.availabilitySets = [];
    if (canLoad) {
      this.availabilitySets = await this.AvailabilityUtils.getAvailabilities(this.user);
      this.availabilityLoading = false;
      this.AvailabilityUtils.resetAvailabilitySets(this.availabilitySets);
    }
  }

  async submit() {
    if (this.form.$invalid) {
      throw new Error('invalid form');
    }

    await this.AvailabilityUtils.saveAvailability(this.availabilitySets);

    this.form.$setPristine();
  }

  cancel() {
    this.form.$setPristine();
    this.AvailabilityUtils.resetAvailabilitySets(this.availabilitySets);
  }
}

export default {
  controller: AvailabilitiesTab,
  controllerAs: 'ctrl',
  templateUrl: availabilitiesTabComponentUrl,
};
